import {constants} from "../../../constants";

export default class OpenHelp {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default(data) {
        this.gb.emitters.emit.web.openHelp(data);
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.EDIG:
                event["openHTML"]  = this._default;
                event["toggleMenu"]  = this._default;
                break;
            case constants.HNR:
                event["toggleHelp"] = this._default;
                break;
            default:
                event["openHelp"] = this._default
        }

        return event;
    }
}
